import TourProductObjectValue from '../ObjectValue/TourProduct';
import Product from './Product';

export default class extends Product {
    constructor(data) {
        super(data.hotelOffer.attributes);

        this.type = 'HotelOfferProduct';

        let element = data.hotelOffer?.id || null;
        if (typeof element !== 'undefined') {
            this.id = element;
        }

        element = data.hotelOffer;
        if (typeof element !== 'undefined') {
            this.hotelOffer = element;
        }

        return new TourProductObjectValue(this);
    }
}